export default async function errorDeviceStorage() {
    return null;
}
